// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class QpsignatureRecipient {
    static getAttributeTypeMap() {
        return QpsignatureRecipient.attributeTypeMap;
    }
}
QpsignatureRecipient.discriminator = undefined;
QpsignatureRecipient.additionalProperties = false;
QpsignatureRecipient.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    },
];
//# sourceMappingURL=qpsignatureRecipient.js.map